<template>
  <layout-component>
    <div class="banner banner-discover">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-9 title-wrapper">
            <h1 class="left-bullet pb-1 pb-lg-0"><anim-text :text="$t('w.discover.title-banner')" /></h1>
          </div>
        </div>

        <div class="row mb-1 mb-lg-4">
          <div class="col-md-12">
            <div class="img-wrapper">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-discover-01-new.webp" alt="Sonotron building" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-discover">
      <div class="container">
        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-6">
              <p class="h4-style bottom-cut" v-html="$t('w.discover.title-01')"></p>
              <p>{{'w.discover.text-01'|t}}</p>
              <p>{{'w.discover.text-02'|t}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2 mb-lg-0">
            <h2><anim-text :text="$t('w.discover.title-02')" /></h2>
          </div>
        </div>
        <div class="row d-md-flex align-items-md-center mb-3 mb-lg-5 wide-left-discover-wrapper">
          <div class="col-md-5">
            <div class="wide-left wide-left-discover d-none d-md-block">
              <div class="noise">
                <b-img src="/storage/img/pic/pic-discover-02.webp" alt="discover sonotron" />
              </div>
            </div>
          </div>
          <div class="wide-left col-md-7">
            <div class="noise">
              <b-img src="/storage/img/pic/pic-discover-03.webp" alt="discover sonotron" />
            </div>
          </div>
        </div>

        <div class="row d-md-flex justify-content-md-center mb-3 mb-lg-5">
          <div class="col-md-6">
              <h2 class="br-title bottom-cut"><anim-text :text="$t('w.discover.title-03')" /></h2>
              <p>{{'w.discover.text-03'|t}}</p>
          </div>
        </div>
      </div>

      <div class="container block-points pb-4 pb-lg-5">
          <div class="row d-flex align-items-center">
              <div class="col-md-5">
                <div class="noise">
                  <b-img src="/storage/img/pic/pic-discover-04.webp" alt="discover sonotron" />
                </div>
              </div>

              <div class="col-md-6 offset-md-1 offset-lg-1 col-lg-4 mt-15">
                  <p class="h4-style bottom-cut mt-2 mt-md-2 mt-lg-4" v-html="$t('w.discover.title-04')"></p>

                  <p>{{'w.discover.text-04' | t }}</p>
              </div>
          </div>

          <div class="row">
              <div class="col-md-6 col-lg-4">
                  <p class="h4-style bottom-cut mt-2 mt-md-4 mt-lg-5" v-html="$t('w.discover.title-05')"></p>
                  <p>{{'w.discover.text-05'|t}}</p>
              </div>

              <div class="col-md-6 col-lg-4 offset-lg-2">
                  <p class="h4-style bottom-cut mt-2 mt-md-4 mt-lg-5" v-html="$t('w.discover.title-06')"></p>
                  <p>{{'w.discover.text-06'|t}}</p>
              </div>
          </div>
      </div>

      <div class="banner-prefooter banner-prefooter-discover noise">
          <div class="container">
              <p class="h2-style">
                  <span><anim-text :text="$t('w.discover.big-cta-prefooter')" /></span>
                  <router-link class='btn-link btn-link-big left-bullet' to='/book' exact><anim-text :text="$t('w.discover.view-our-spaces')" /></router-link>
              </p>
          </div>
      </div>
    </div>

  </layout-component>
</template>

<script>
    export default {
      mounted() {
        $('.title-anim-wrapper:in-viewport').addClass('in-viewport');
        if ( $( '.banner-prefooter .title-anim-wrapper' ).is( ':in-viewport' ) ) {
          $('.banner-prefooter').addClass('in-viewport');
        }
      }
    }
</script>
